import { FetchClient, storeClient } from '@/shared/api/client';
import { FormContactBody } from './types';
import { SeoResponse } from '@/shared/api/types';

export const sendContactForm = async (
	body: FormContactBody,
	fetch?: FetchClient
): Promise<boolean> => {
	try {
		await storeClient(
			'/contact/mail-send',
			{
				method: 'POST',
				body,
			},
			fetch
		);

		return true;
	} catch (e) {
		return false;
	}
};
